import { TextField } from '@mui/material'
import { FC, useCallback, useEffect } from 'react'
import toast from 'react-hot-toast'
import { useTranslation } from 'react-i18next'
import {
  PaymentOptionsType,
  PaymentProvider,
} from '../../third-party/PaymentProvider'
import { PaymentProviderFactory } from '../../third-party/PaymentProviderFactory'

const BankAccountFields: FC<BankAccountFieldsProps> = (props) => {
  const { payment, onSucceed, onError } = props

  const { t } = useTranslation()

  const handleError = useCallback(
    (error: unknown) => {
      toast.error(String(error))
      onError(error)
    },
    [onError]
  )

  useEffect(() => {
    ;(async () => {
      const paymentOptions: PaymentOptionsType = {
        ...payment,
        method: 'bank',
        onSucceed,
        handleError,
      }
      await PaymentProviderFactory.initPaymentProvider(
        payment.method,
        paymentOptions
      )
    })()
  }, [handleError, onSucceed, payment])

  return (
    <>
      <TextField
        label={t('Bank code / BSB')}
        name="bsb"
        id={PaymentProvider.formIds.ACCOUNT_BSB}
        placeholder={t('Max 6-digit number')}
        required
        inputMode="numeric"
        slotProps={{
          htmlInput: {
            maxLength: 6,
            pattern: '\\d+',
          },
        }}
      />
      <TextField
        label={t('Account number')}
        name="bankAccount"
        id={PaymentProvider.formIds.ACCOUNT_NUMBER}
        placeholder={t('Max 9-digit number')}
        required
        inputMode="numeric"
        slotProps={{
          htmlInput: {
            maxLength: 9,
            pattern: '\\d+',
          },
        }}
      />
      <TextField
        label={t('Account holder name')}
        name="bankAccountName"
        id={PaymentProvider.formIds.ACCOUNT_NAME}
        required
      />
    </>
  )
}

type BankAccountFieldsProps = {
  payment: { method: 'ezidebit' | 'ezypay' | 'paychoice' | 'stripe' }
  onSucceed: (result: any) => void
  onError: (error: unknown) => void
}

export { BankAccountFields }
export type { BankAccountFieldsProps }
